import ChatsDocuments from './ChatsDocuments';

export default ChatsDocuments;
